import Head from 'next/head'
import { generateUrl } from '../../utils'
import config from '../../../config.json'
import { thumbnailSrc } from '../../utils/news'

export function NewsMetas({ news, buildTime }) {

    const relativeUrl = generateUrl(news, 'news')
    const imageUrl = thumbnailSrc(news.thumbnail)
    let mainService = null
    if (news.main_service_id) {
        mainService = news.services.find((s) => s.id === news.main_service_id)
    }

    return <Head>
        <title>{news?.seo_title ?? news?.title}</title>
        <link rel="canonical" href={`${config.core.rootUrl}${relativeUrl}`} />
        <meta
            name="description"
            content={news?.seo_des ?? news?.abst?.slice(0, 160)}
        />
        <meta property="og:title"
            content={news?.og_title ?? news?.seo_title ?? news?.title} />
        <meta
            property="og:description"
            content={news?.og_des ?? news?.seo_des ?? news?.abst?.slice(0, 160) ?? news?.title}
        />
        <meta property="og:url" content={`${config.core.rootUrl}${relativeUrl}`} />
        <meta property="og:type" content="article" />
        {imageUrl && <meta property="og:image" content={`${config.core.rootUrl}${imageUrl}`} />}
        {news.thumbnail?.alt && <meta property="og:image:alt" content={news.thumbnail?.alt} />}
        {news.thumbnail?.filemeta?.width && <meta property="og:image:width" content={news.thumbnail?.filemeta?.width} />}
        {config.core.website_name && <meta property="og:site_name" content={config.core.website_name} />}
        {news.published_at && <meta property="article:published_time" content={news.published_at} />}
        {news.modified_at && <meta property="article:modified_time" content={news.modified_at} />}
        {/* <meta property="article:author" content="Author Name" /> */}
        {mainService?.title && <meta property="article:section" content={mainService.title} />}
        {news.tags?.map((tag, idx) => <meta property="article:tag" content={tag} key={idx} />)}
        <meta
            key="previewlarge"
            name="robots"
            content="max-image-preview:large"
        />,
        <meta key="lastupdate" name="last-update-time" content={buildTime} />
    </Head>
}